module.exports = __webpack_public_path__ + "img/MEDIA015.752e0138.jpg";